import { Button } from "../../components";
import type { Grade as GradeValue } from "../../state/profile";

const LABEL = ["Again", "Hard", "Good", "Easy"] as const;

type GradeProps = { onGrade: (g: GradeValue) => void; suggested?: GradeValue };

export function Grade({ onGrade, suggested }: GradeProps) {
  return (
    <div class="stage stage-grade">
      <p class="stage-kicker">
        {suggested !== undefined ? `Be honest — the mic thinks "${LABEL[suggested]}"` : "Be honest — how did that go?"}
      </p>
      <div class="grade-row">
        {([0, 1, 2, 3] as const).map((g) => (
          <Button
            key={g}
            variant={g >= 2 ? "primary" : "ghost"}
            breathing={suggested === g}
            onClick={() => onGrade(g)}
          >
            {LABEL[g]}
          </Button>
        ))}
      </div>
    </div>
  );
}
